module.exports = __webpack_public_path__ + "media/images/photo/plans/common/img_online-photo-bc96cfce89974dfaaf9bf5c7aef34318.jpg";